<template>
  <v-app style="background-color: transparent;">
      <!-- conteneur pour les etoiles -->
      <div id="starsContainer" v-if="displayStars">
        <div v-for="(star, index) in stars" :key="index" class="star" :style="'top: '+star.x+'px; left: '+star.y+'px; width: '+star.size+'px;height: '+star.size+'px; animation-delay: '+(star.x+star.y)%2+'s'"></div>
      </div>

      <Header v-if="$route.meta.showNav" :themes="themes" :theme="theme" :settings="settings" @openLogin="openLoginModal" @logout="logout"/>

      <v-main style="margin-top: -70px; margin-bottom: -50px;">
        <v-parallax scale=".7" :src="require('@/assets/images/Background.png')" style="padding-top: 70px; padding-bottom: 200px;" v-if="$route.meta.parallax">
          <router-view class="w-100 overflow-hidden" :themes="themes" :theme="theme" :settings="settings"/>
        </v-parallax>
        <div style="padding-top: 70px; padding-bottom: 70px;" v-else>
          <router-view class="w-100 overflow-hidden"  :themes="themes" :theme="theme" :settings="settings"/>
        </div>
      </v-main>

      <footer class="pa-3 text-center header" v-if="$route.meta.showNav">
        COPYRIGHT &copy; {{ new Date().getFullYear() }} leatvprod, All rights Reserved
      </footer>
        
      <!-- Modal de connexion -->
      <LoginModal v-model="loginModalIsOpen" @logout="logout"/>

  </v-app>
</template>

<script>
import { useDisplay } from 'vuetify'
import { useTheme } from 'vuetify'

import { getAuth, signOut, deleteUser } from '@firebase/auth'

import { useUserStore } from '@/store/user.js'

import logger from "@/utils/logger.js"

import Profile from "@/classes/Profile.js"
import Setting from "@/classes/Setting.js"

import Header from '@/components/Header.vue'
import LoginModal from '@/components/LoginModal.vue'

import dark from "@/themes/dark.js"
import magic from "@/themes/magic.js"

export default {
  components: {
    Header,
    LoginModal,
  },
  // initialisation de certaine fonction de vuetify
  setup() {
    const { mdAndUp } = useDisplay()
    const theme = useTheme()
    
    const themes = {
      dark: dark,
      magic: magic,
    }

    return { mdAndUp, theme, themes }
  },
  data() {
    return {
      unsub: [],
      token: null,

      userStore: useUserStore(),

      settingsUnsub: [],
      settings: null,

      displayStars: false,
      stars : [],

      loginModalIsOpen: false,
    }
  },
  async mounted() {
    //check for connection
    getAuth().onAuthStateChanged(async (user) => {
      if(user) {
        this.unsub.push(await Profile.listenById(user.uid, async profile => {
          if(profile) {
            this.userStore.profile = profile
            this.userStore.uid = user.uid
            this.userStore.isLoggedIn = true

            let tmp_lastLogin = new Date().getTime()
            if(!this.userStore.profile.lastLogin || tmp_lastLogin - this.userStore.profile.lastLogin > 1000*60*1) {
              this.userStore.profile.lastLogin = tmp_lastLogin
              await this.userStore.profile.save()
              await logger.log(this.userStore,"Connexion")
            }

          }else{
            deleteUser(user).then(() => {
              this.userStore.isLoggedIn = false
              this.userStore.profile = null
              this.userStore.uid = null
            }).catch((error) => {
              console.log(error)
            })
          }
          this.checkForChanges()
        }))
      }else{
        this.userStore.profile = null
        this.userStore.uid = null
        this.checkForChanges()
      }
    })

    //recuperation de l'IP de l'utilisateur
    const response = await fetch('https://api.ipify.org?format=json')
    const data = await response.json()
    this.userStore.ip = data.ip

    //initialisation des etoiles
    this.stars = this.getStars()

    //recuperation des parametres
    this.settingsUnsub.push(Setting.listenById('global', async (settings) => {
      this.settings = settings
    }))

    //check pour l'affichage du theme et des etoiles
    this.checkForChanges()
  },
  methods: {
    //ouverture du modal de connexion
    openLoginModal() {
      this.loginModalIsOpen = true
    },

    //deconnexion de l'utilisateur
    async logout() {
      await logger.log(this.userStore,"Déconnexion")
      signOut(getAuth()).then(() => {
        this.userStore.profile = null
        this.userStore.uid = null
        this.userStore.isLoggedIn = false
        this.loginModalIsOpen = false
      }).catch((error) => {
        console.log(error)
      })
    },

    //Verifie si le theme et les etoiles doivent etre affichés
    checkForChanges() {
      if(this.userStore.profile && this.userStore.profile.parameters) {
        this.theme.global.name.value = this.userStore.profile.parameters.theme
        this.displayStars = this.userStore.profile.parameters.starsEnabled
      }else{
        this.theme.global.name.value = "dark"
        this.displayStars = false
      }
    },

    //generer la grilles d'etoiles
    getStars(){
      let stars = []
      let starsRow = 10
      let starsCol = 20
      for(let i = 0; i < starsRow; i++){
        for(let j = 0; j < starsCol; j++){
          let x = window.innerHeight/starsRow * i + Math.floor(Math.random() * (window.innerHeight/starsRow))
          let y = window.innerWidth/starsCol * j + Math.floor(Math.random() * (window.innerWidth/starsCol))
          let size = Math.floor(Math.random() * 4) + 2
          stars.push({
            x: x,
            y: y,
            size: size,
          })
        }
      }
      return stars
    },
  },
}
</script>